import axios from "./axios";
import { call, put, takeLatest, spawn } from "redux-saga/effects";
import { CREATE_WITHDRAW_REQUEST, GET_WITHDRAWS_REQUEST } from "../types";
import { clientErrorMessage, delay } from "./reusable";
import {
  createWithdrawFailure,
  createWithdrawLoading,
  createWithdrawSuccess,
  getWithdrawsFailure,
  getWithdrawsLoading,
  getWithdrawsSuccess,
} from "../action";

const ajaxDBCalls = {
  createWithdraw: async (formData) => {
    const response = await axios.post(`/fund/withdraw/create`, formData);
    return response;
  },
  getWithdraws: async () => {
    const response = await axios.get(`/fund/withdraw`);
    return response;
  },
};

function* createWithdraw({ payload }) {
  try {
    yield put(createWithdrawLoading(true));

    const res = yield call(ajaxDBCalls.createWithdraw, payload);

    yield put(createWithdrawSuccess(res.data));

    yield put(createWithdrawLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(createWithdrawFailure(errorMessage));
    yield put(createWithdrawLoading(false));
    yield delay();
    yield put(createWithdrawFailure(""));
  }
}
function* getWithdraws({ payload }) {
  try {
    yield put(getWithdrawsLoading(true));

    const res = yield call(ajaxDBCalls.getWithdraws, payload);

    yield put(getWithdrawsSuccess(res.data));

    yield put(getWithdrawsLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      console.log("something is wrong", err.response.data);

      const { message } = err.response.data;
      errorMessage = message;
    }

    yield put(getWithdrawsFailure(errorMessage));
    yield put(getWithdrawsLoading(false));
    yield delay();
    yield put(getWithdrawsFailure(""));
  }
}

//Watchers
function* createWithdrawWatcher() {
  yield takeLatest(CREATE_WITHDRAW_REQUEST, createWithdraw);
}
function* getWithdrawsWatcher() {
  yield takeLatest(GET_WITHDRAWS_REQUEST, getWithdraws);
}

export default function* withdrawSagas() {
  yield spawn(createWithdrawWatcher);
  yield spawn(getWithdrawsWatcher);
}
